import { MAX_LENGTH } from '@/shared/constants/validationVars';
import { helpers } from '@vuelidate/validators';

import {
  createMaxLengthRule,
  createMinLengthRule,
  createRegexMark,
  createValidationRule,
} from '../validate';

export const docCadNumberRules = {
  regex: [
    createRegexMark('Только цифры и двоеточия (:)', ':', '0-9'),
    createValidationRule(
      {
        message: 'Кадастровый номер не должен быть нулевым',
      },
      '^(?!0+$).+$'
    ),
    helpers.withParams(
      {
        regex: '^.',
        message: 'Нельзя ставить двоеточие (:) в начале',
      },
      helpers.regex(new RegExp('^[0-9]'))
    ),
  ],
  maxLength: createMaxLengthRule(MAX_LENGTH),
  minLength: createMinLengthRule(12),
};
